import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import i18n from './i18n'
import VueSweetalert2 from 'vue-sweetalert2';
// @ts-ignore
import VueHtmlToPaper from 'vue-html-to-paper';

import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueAnalytics from 'vue-analytics';
// @ts-ignore
import * as VueGoogleMaps from 'vue2-google-maps'
 
// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css';
 
import Vue2Filters from 'vue2-filters'


Vue.config.productionTip = false
// Install BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

Vue.use(VueSweetalert2);
Vue.use(VueHtmlToPaper);
Vue.use(Vue2Filters)

// // Configuration VueAnalytics
// Vue.use(VueAnalytics, {
//   id: 'UA-124509415-20',
//   router
// });


Vue.use(VueGoogleMaps, {
  load: {
    //key : 'AIzaSyB0Wp7l4BPpclXI9-EW7S03-SSvz4CSp_c',
    key: 'AIzaSyB0Wp7l4BPpclXI9-EW7S03-SSvz4CSp_c',
    libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)
 
    //// If you want to set the version, you can do so:
    // v: '3.26',
  },
 
  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,
 
  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then disable the following:
  // installComponents: true,
});

Vue.component('font-awesome-icon', FontAwesomeIcon)

library.add(fas)

export const Vm = new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
